// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__Lmkt9","spinner":"LoadingOverlay_spinner__pAdCv","spin":"LoadingOverlay_spin__wSTV1","text":"LoadingOverlay_text__g7RYq"};